'use strict';

var HTTPService = require('../services/http-service');
var NotificationService = require('../services/notification-service');
var Pace = require('./pace');
var blzEvent = require('../services/tracking/blz-event.js');

function interaction(action, label, values) {
  blzEvent.interaction(
    {},
    {
      action: action || '',
      label: label || '',
      values: values || ''
    }
  );
}

function newQuestion(label) {
  Pace.open();
  interaction('Questions', label);
  return HTTPService.get('/api/htmls/personify/questions/random?pageName=' + blz.pageName)
    .then(HTTPService.handleClientError)
    .always(Pace.close);
}

$('body').on('submit', '.questionnaire', function (e) {
  e.preventDefault();

  var $form = $(this);
  var $wrapper = $form.closest('.questions');
  var question = $form.data();
  var options = [];
  var url = '/api/personify/questions/' + question.id + '/answers';

  $form.find('input:checked').each(function () {
    options.push($(this).data('option'));
  });

  if (!options.length) {
    return NotificationService.warning(blz.locale.INVALID_ANSWER);
  }

  var data = {
    choiceType: question.choiceType,
    values: options,
    userId: blz.me.id
  };

  Pace.open();

  HTTPService.post(url, data)
    .then(HTTPService.handleClientError)
    .then(function () {
      $wrapper.empty();
      interaction(
        'Questions',
        'Choosed-Options',
        (
          data.values.map(function (opt) {
            return opt.value;
          }) || []
        ).join('\n')
      );

      newQuestion('load').then(function (questionData) {
        if (questionData) {
          $wrapper.html(questionData);
        }
      });
    })
    .catch(NotificationService.error)
    .always(Pace.close);
});

$('body').on('click', '.js-skip-question', function (e) {
  e.preventDefault();
  var $wrapper = $(this).closest('.questions');
  newQuestion('skip').then(function (questionData) {
    if (questionData) {
      $wrapper.html(questionData);
    }
  });
});
